import { preferencesActions } from '../../../../actions/preferencesActions';
import { TTS_SETTINGS_KEY } from '../../../../constants';
import { loadPersistedState } from '../../../middleware/storageMiddleware';

export type TTSSettingsReducerState = {
  language?: string;
  voiceId?: string;
  areSubtitlesGeneratedWithAudio: boolean;
};

const defaultState: TTSSettingsReducerState = {
  language: undefined,
  voiceId: undefined,
  areSubtitlesGeneratedWithAudio: true,
};

export const loadDefaultValue = () => {
  const json = loadPersistedState(TTS_SETTINGS_KEY);
  if (json) {
    return JSON.parse(json) as TTSSettingsReducerState;
  }
  return defaultState;
};

export function ttsSettingsReducer(
  state: TTSSettingsReducerState = defaultState,
  action?: any
): TTSSettingsReducerState {
  switch (action.type) {
    case preferencesActions.TTSSettings_Set:
      return {
        ...state,
        language: action.payload.language,
        voiceId: action.payload.voice,
        areSubtitlesGeneratedWithAudio: action.payload.generateSubtitles,
      };
    default:
      return state;
  }
}
